import React from "react";

// Import SVG files correctly
const countries = [
  { src: require("../assets/in.svg").default, alt: "India" },
  { src: require("../assets/ca.svg").default, alt: "Canada" },
  { src: require("../assets/us.svg").default, alt: "USA" },
  { src: require("../assets/sg.svg").default, alt: "Singapore" },
  { src: require("../assets/gb.svg").default, alt: "United Kingdom" },
  { src: require("../assets/au.svg").default, alt: "Australia" },
  { src: require("../assets/ae.svg").default, alt: "UAE" },
];

const MarqueeFlags = () => {
  return (
    <div className="bg-[#FFFFFF] py-10 text-center">
      <h2 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mb-10 drop-shadow-sm">
        Our Targeted Countries
      </h2>
      {/* <p className="text-gray-700 mb-6">
        We proudly export premium Multani Mitti to these countries, ensuring superior quality and customer satisfaction.
      </p> */}

      <div className="relative overflow-hidden w-full py-4">
        <div className="flex items-center gap-10 whitespace-nowrap animate-marquee">
          {[...countries, ...countries].map((country, index) => (
            <img
              key={index}
              src={country.src}
              alt={country.alt}
              className="h-16 w-auto object-contain"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarqueeFlags;